var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71477 5.90092C6.71477 5.44069 7.08786 5.06759 7.54809 5.06758L14.6498 5.06748C14.8708 5.06748 15.0827 5.15527 15.239 5.31155C15.3953 5.46783 15.4831 5.6798 15.4831 5.90081L15.4831 12.9015C15.4831 13.3617 15.11 13.7348 14.6498 13.7348C14.1895 13.7348 13.8164 13.3617 13.8164 12.9015L13.8164 7.91266L6.98945 14.7396C6.66401 15.0651 6.13637 15.0651 5.81093 14.7396C5.4855 14.4142 5.4855 13.8866 5.81093 13.5611L12.6379 6.73417L7.54812 6.73425C7.08788 6.73425 6.71478 6.36116 6.71477 5.90092Z",
    fill: "#003193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpRight);
export default __webpack_public_path__ + "static/media/ic-arrow-up-right.c754e2e2dd082f83d9343c6721f73e19.svg";
export { ForwardRef as ReactComponent };